import React, {Component} from 'react';
import FlowersCTA from './FlowersCTA';
import Header from '../../../../../shared/library/Header/Header';
import {buildFuneralHomeFlowersUrl} from '../../../../../shared/utilities/urlHelpers';
import {getGATags} from '../../../../../shared/utilities/GAHelpers';
import {breakPointChecker} from '../../../../../shared/utilities/breakPointChecker.js';
import './css/FlowersCTA.styl';

export default class FlowersAd extends Component {
  state = {
    tablet: false,
    largeMobile: false,
    smallMobile: false,
  };

  componentDidMount() {
    window.addEventListener('resize', this.checkBreakPoint);
    this.checkBreakPoint();
  }

  checkBreakPoint = () => {
    this.setState({
      tablet: breakPointChecker(),
      largeMobile: breakPointChecker(500),
      smallMobile: breakPointChecker(300),
    });
  };

  handleSendFlowersClick = () => {
    getGATags({
      eventCategory: 'fhd_flowers',
      eventAction: 'fhd_flowersad_click',
      eventLabel: 'fhd_flowerad',
    });
  };

  render() {
    const title = () => {
      if (this.state.smallMobile) {
        return 'Flowers';
      } else if (this.state.largeMobile) {
        return 'Sympathy Flowers';
      } else if (this.state.tablet) {
        return 'Popular Sympathy Flowers';
      }
      return 'Most Popular Sympathy Flowers';
    };

    return (
      <div className="flowers-ad">
        <div className="flowers-cta-header">
          <Header type="normal" className="flowers-ad__header" title={title()}>
            <a
              href={buildFuneralHomeFlowersUrl(this.props.flowersUrlOptions)}
              className="flowers-cta-link"
              data-ga-no-auto-tag
              onClick={this.handleSendFlowersClick}
            >
              View all
            </a>
          </Header>
        </div>

        <div className="flowers-cta-items">
          {this.props.flowersAdItems.map((value, index) => (
            <FlowersCTA key={index} data={value} />
          ))}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/reactModules/pages/Profile/components/Shared/FlowersAd/index.js